import { NavLink } from 'react-router-dom'
import React from 'react'
import Page from 'component/page-container'
import './style.css'

/* global API */

const UserListPage = props => {
    const [userList, setUserList] = React.useState([])
    React.useEffect(() => {
        (async () => {
            setUserList(await API.instance().getUserList())
        })()
    }, [])

    return (
        <Page className="user-list-page" h1="Люди">
            <div className="page__inner">
                <p>Пока просто табличкой, если вдруг посмотреть список или найти контакты надо. В будущем прикрутим быстроссылки, списки процессов и прочее.</p>
                <table className="user-list">
                    <thead>
                        <tr>
                            <td>Имя</td>
                            <td>Фамилия</td>
                            <td>Электронная почта</td>
                            <td>Телефон</td>
                            <td>Телеграм</td>
                        </tr>
                    </thead>
                    <tbody>
                        {userList.map((user, key) =>
                            <tr className="user-list__user" key={key}>
                                <td className="user-list__name">
                                    <NavLink to={`/people/${user.telegram}`}>
                                        {user.name} {user.surname}
                                    </NavLink>
                                </td>
                                <td className="user-list__email">{user.email}</td>
                                <td className="user-list__phone">{user.phone}</td>
                                <td className="user-list__telegram">{user.telegram}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Page>
    )
}

export default UserListPage
